/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Next_PeriodInputs */



/**
* | output |
* | --- |
* | "Next billing period" |
*
* @param {Billing_Next_PeriodInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const billing_next_period = /** @type {((inputs?: Billing_Next_PeriodInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Next_PeriodInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nächster Abrechnungszeitraum")
	return /** @type {LocalizedString} */ ("Next billing period")
});